"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderVoucherSchema = exports.MonetaryOrderVoucherSchema = exports.ExperienceOrderVoucherSchema = exports.OrderVoucherBaseSchema = void 0;
var zod_1 = require("zod");
var Common_schema_1 = require("./Common.schema");
var OrderVoucherRefundSchema = zod_1.z.object({
    createdAt: zod_1.z.string(),
    uuid: zod_1.z.string(),
    refundValue: Common_schema_1.PriceSchema,
    reason: zod_1.z.string(),
});
exports.OrderVoucherBaseSchema = Common_schema_1.VoucherBaseSchema.extend({
    refunds: zod_1.z.array(OrderVoucherRefundSchema),
});
exports.ExperienceOrderVoucherSchema = exports.OrderVoucherBaseSchema.extend({
    orderItem: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
});
exports.MonetaryOrderVoucherSchema = exports.OrderVoucherBaseSchema;
exports.OrderVoucherSchema = zod_1.z.union([
    exports.ExperienceOrderVoucherSchema,
    exports.MonetaryOrderVoucherSchema,
]);
